module.exports = __webpack_public_path__ + "static/green1-ec49c7778cb4a88db926cd0aa1580297.png";